import React from 'react';
import ReferredSchoolsPage from '../domains/admin/components/ReferredSchoolsPage';

const AdminReferredSchools: React.FC = () => {
  return <ReferredSchoolsPage />;
};

export default AdminReferredSchools;
